'use strict';//Indicating browser should run only in java script mode

var EMRConfirmationMessage = angular.module('EMR.ConfirmationMessage', [])